if (!customElements.get("social-media-highlights-slider")) {
  class SocialMediaHighlightsSlider extends HTMLElement {
    constructor() {
      super();

      /** Store Content Card before initilation */
      this.slideContent = this.querySelector('.section__social-media-highlights--content-card');

      /** Swiper opts & init */
      this.swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      this.swiperLayout = this.getAttribute("data-swiper-layout") || "default";
      const swiperOptions = this.swiperOptions;
      const swiperLayout = this.swiperLayout;

      this.sliderItem = this.querySelector('.swiper');

      this.sliderOptions = {
        slidesPerView: 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        },
        on: {
          afterInit: () =>
            this.querySelector(".swiper-smh").removeAttribute("style")
        }
      };

      if (swiperOptions.autoplaySpeed != 0 && swiperLayout === "default") {
        this.sliderOptions = {
          speed: swiperOptions.autoplaySpeed || 10000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "default" ) {
        this.sliderOptions = {
          loop: true,
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "stacked") {
        this.sliderOptions = {
          navigation: {
            prevEl: ".swiper-button--prev",
            nextEl: ".swiper-button--next"
          },
          ...this.sliderOptions
        };
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.shouldUseCssMarquee()) {
        this.initCssMarquee();
        return;
      }
      this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
      this.toggleSlideContentCard();
    }

    shouldUseCssMarquee() {
      return this.swiperLayout === "default" && Number(this.swiperOptions.autoplaySpeed) > 0;
    }

    initCssMarquee() {
      const swiperEl = this.sliderItem;
      const wrapperEl = swiperEl.querySelector(".swiper-wrapper");
      if (!wrapperEl) return;

      swiperEl.setAttribute("data-smh-marquee", "");

      const originals = Array.from(wrapperEl.children);
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("data-marquee-clone", "");
        clone.querySelectorAll("a, button, input, [tabindex]").forEach((el) => {
          el.setAttribute("tabindex", "-1");
        });
        wrapperEl.appendChild(clone);
      });

      const durationSec = (Number(this.swiperOptions.autoplaySpeed) * originals.length) / 1000;
      swiperEl.style.setProperty("--smh-marquee-duration", `${durationSec}s`);
      // 디자인 의도: 슬라이드끼리 띠처럼 붙임. admin 글로벌 spacing 무관하게 0 강제.
      swiperEl.style.setProperty("--smh-gap-mobile", "0px");
      swiperEl.style.setProperty("--smh-gap-desktop", "0px");

      const updateViewport = () => {
        swiperEl.style.setProperty("--smh-viewport", `${swiperEl.clientWidth}px`);
        // margin-right 포함 합산 필수 — wrapper.offsetWidth 는 자식 margin 미포함이라
        // -50% 이동 시 한 세트 폭과 어긋나 매 사이클 점프 발생.
        let setW = 0;
        originals.forEach((s) => {
          const cs = window.getComputedStyle(s);
          if (cs.display === "none") return;
          setW += s.offsetWidth + (parseFloat(cs.marginRight) || 0);
        });
        if (setW > 0) {
          swiperEl.style.setProperty("--smh-set-width", `${setW}px`);
        }
      };
      updateViewport();
      if ("ResizeObserver" in window) {
        this._marqueeRO = new ResizeObserver(updateViewport);
        this._marqueeRO.observe(swiperEl);
      } else {
        this._marqueeResizeHandler = debounce(updateViewport, 200);
        window.addEventListener("resize", this._marqueeResizeHandler);
      }

      if ("IntersectionObserver" in window) {
        this._marqueeIO = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              swiperEl.classList.toggle("smh-paused", !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this._marqueeIO.observe(swiperEl);
      }

      swiperEl.style.removeProperty("opacity");
    }

    disconnectedCallback() {
      this._marqueeRO?.disconnect();
      this._marqueeIO?.disconnect();
      if (this._marqueeResizeHandler) {
        window.removeEventListener("resize", this._marqueeResizeHandler);
      }
    }

    /** Hide / Show Content Card */
    toggleSlideContentCard() {
      let swiperInitialized = false;
      if (DeviceDetector.isMobile()) {
        this.swiper.removeSlide(2);
      }

      const updateSlideContent = () => {
        if (swiperInitialized) {
          if (DeviceDetector.isMobile()) {
            this.swiper.removeSlide(2);
          } else {
            this.swiper.addSlide(2, this.slideContent)
          }
        }
      };

      updateSlideContent();

      window.addEventListener(
        "resize",
        debounce(() => {
          updateSlideContent();
        }, 200)
      );

      this.addEventListener("swiper:init", () => {
        swiperInitialized = true;
      });
    }
  }

  customElements.define("social-media-highlights-slider", SocialMediaHighlightsSlider);
}
